module.exports = __webpack_public_path__ + "static/img/icon_yuguyf.ed14d10a.png";